import { HttpEvent, HttpHandler, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MsalInterceptor } from "@azure/msal-angular";
import { Observable } from "rxjs";

@Injectable()
export class MsalCustomInterceptor extends MsalInterceptor {
	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		if (req.url.includes("/Public/"))
		{
			return <any>next.handle(req);
		}
		else
		{
			return super.intercept(req, next);
		}
	}
}
